export default __webpack_public_path__ + "static/RightCross-9db41d895dc022eca38a52df68d0ba19.png";